import {
  INSTITUTE_LEGAL_STATUS_CHOICES,
  TA_SERVICE_CHOICES,
  BASIC_SERVICE_CHOICES,
  WORLD_REGION_CHOICES,
  SDGs
} from "utils/choices.jsx";

const schema = {
  title: "",
  description: "",
  type: "object",
  properties: {
    legal_status: {
      type: "string",
      title: "Legal Status",
      options: INSTITUTE_LEGAL_STATUS_CHOICES["TechnicalAssistance"]
    },
    working_regions: {
      type: "string",
      title: "Region(s) of Intervention",
      options: WORLD_REGION_CHOICES
    },
    services: {
      type: "string",
      title: "Services offered",
      options: TA_SERVICE_CHOICES
    },
    focus_areas: {
      type: "string",
      title: "Expertise (non-financial areas)",
      options: BASIC_SERVICE_CHOICES
    },
    sustainable_development_goals: {
      type: "string",
      title: "Sustainable Development Goals",
      options: SDGs
    },
    region: {
      type: "string",
      title: "Region",
      options: WORLD_REGION_CHOICES
    }
  }
};

const uiSchema = [
  {
    container: "griditem",
    items: {
      region: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      sustainable_development_goals: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      legal_status: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      working_regions: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      services: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      focus_areas: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  }
];

export const TechnicalAssistanceFormSchema = {
  schema: schema,
  uiSchema: uiSchema
};
